import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  deepSpread,
  mergeDocuments,
  mergeWebsocketDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformUsersSelfMfa } from './users-mfa.transformers';
import type { UsersMfaCollection } from './users-mfa.types';

export function usersMfaReducer(
  state: CollectionStateSlice<UsersMfaCollection> = {},
  action: CollectionActions<UsersMfaCollection>,
): CollectionStateSlice<UsersMfaCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'usersMfa') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<UsersMfaCollection>(
          state,
          transformIntoDocuments([result], transformUsersSelfMfa),
          order,
          ref,
        );
      }
      return state;
    }

    case 'API_UPDATE_SUCCESS': {
      if (action.payload.type === 'usersMfa') {
        const { ref, originalDocument, delta } = action.payload;

        const mfaDetails = delta.mfa;
        if (mfaDetails) {
          return mergeWebsocketDocuments<UsersMfaCollection>(
            state,
            [
              deepSpread(originalDocument, {
                mfa: mfaDetails,
              }),
            ],
            ref,
          );
        }
      }

      return state;
    }

    default:
      return state;
  }
}
